import { module } from "angular";
import core from "@gtmhub/core/module";
import employeesCore from "@gtmhub/employees/employees-core.module";
import { GlobalSearchItemComponent } from "@gtmhub/search/components/global-search-item/global-search-item.component";
import { GlobalSearchComponent } from "@gtmhub/search/components/global-search/global-search.component";
import { InsightRedirectModalCtrl, InsightRedirectModalService } from "@gtmhub/search/components/insight-redirect-modal/insight-redirect-modal";
import { NoSearchItemsFoundComponent } from "@gtmhub/search/components/no-search-items-found/no-search-items-found.component";
import { SimpleGlobalSearchComponent, SimpleGlobalSearchCtrl } from "@gtmhub/search/components/simple-global-search/simple-global-search";
import { GlobalSearchService } from "@gtmhub/search/services/global-search-service";
import hotkeys from "@gtmhub/shared/libs/angular-hotkeys/angular-hotkeys.module";
import viewHistory from "@gtmhub/view-history/view-history.module";
import { GlobalSearchComponent as GlobalSearchComponentV2 } from "@webapp/search/components/global-search/global-search.component";
import { InsightRedirectModalCtrlComponent } from "./components/insight-redirect-modal/insight-redirect-modal";
import { GlobalSearchCtrl } from "./controllers/global-search.ctrl";
import searchCore from "./search-core.module";

const mod = module("search", [core, searchCore, hotkeys, employeesCore, viewHistory]);

mod.service("GlobalSearchService", GlobalSearchService);
mod.service("InsightRedirectModalService", InsightRedirectModalService);
mod.controller("GlobalSearchCtrl", GlobalSearchCtrl);
mod.controller("SimpleGlobalSearchCtrl", SimpleGlobalSearchCtrl);
mod.controller("InsightRedirectModalCtrl", InsightRedirectModalCtrl);
mod.component("ghSimpleSearch", SimpleGlobalSearchComponent);
mod.component("ghSearch", GlobalSearchComponent);
mod.component("ghSearchItem", GlobalSearchItemComponent);
mod.component("noSearchItemsFound", NoSearchItemsFoundComponent);
mod.component("insightRedirectModal", InsightRedirectModalCtrlComponent);
mod.downgradeComponent("ghSearchNext", { component: GlobalSearchComponentV2 });

export default mod.name;
